module.exports = __webpack_public_path__ + "static/cad-designs23-20613d71fc10a8ff318af4cfe3c93e72.png";